export const Context = {
  INVENTORY_TEMPLATE: 1,
  INVENTORY_ITEMS: 2,
  OUTREACH_AGGREGATE_REPORT: 3,
  VISIT_HISTORY: 4
};

export const Status = {
  IN_PROGRESS: 0,
  COMPLETE: 1
};

export const LabelByStatus = {
  [Status.IN_PROGRESS]: 'In Progress',
  [Status.COMPLETE]: 'Complete'
};
